var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencilBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.671 6.37683L8.97003 3.95748L10.5829 2.15685C10.9674 1.69959 11.0085 1.70075 11.4363 2.10991L13.2369 3.72281C13.6753 4.12112 13.7022 4.11279 13.2839 4.5762L11.671 6.37683ZM5.62261 13.1293C4.69839 12.3006 3.18365 10.9446 2.92166 10.71L8.16358 4.85791L10.8645 7.27726L5.62261 13.1293ZM1.34591 15.1863L2.11519 11.6102L4.81614 14.0295L1.34591 15.1863ZM14.4936 3.2258L11.7927 0.80645C11.248 0.318548 10.5782 0.350673 10.0859 0.900317L1.12905 10.8997L0.0821107 15.6916C-0.0213958 16.3542 0.33513 16.6736 0.982428 16.4981L5.63064 14.9319L14.5875 4.93257C15.0798 4.38292 15.0379 3.71415 14.4936 3.2258Z",
    fill: "#1F5492"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilBlue);
export default __webpack_public_path__ + "static/media/EditPencilBlue.73a3de0d1940e4a1b7352701c56fe761.svg";
export { ForwardRef as ReactComponent };